import { css, html, LitElement, PropertyValues } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../modal/nn-modal.js';
import '../../atoms/loader/nn-loader.js';
import assetsPath from '../../index.js';

/**
 * Nordnet Chronos modal molecule. Used with chronos card molecule and chronos modal button atom.
 * WRITE THE COMPLETE DOCUMENTATION HERE
 * start - The mobile button href.
 * end - The mobile button text.
 * available - The mobile button text.
 * filterId - .
 * currentChronos - .
 * id - .
 * date - .
 * timeslots - .
 */

interface Timeslots {
  start: string;
  end: string;
  available: boolean;
  filterId: number;
  currentChronos: string;
}

interface DateTimeSlots {
  id: string;
  date: string;
  timeslots: Timeslots[];
}

@customElement('nn-chronos-modal')
export class ChronosModal extends LitElement {
  static styles = css`
    :root {
      --system-selected-bg: #f2f6fd;
    }
    * {
      box-sizing: border-box;
    }
    .chronos-modal-content {
      font-size: var(--nn-chronos-modal_chronos-modal-content_font-size, 16px);
      height: var(
        --nn-chronos-modal_chronos-modal-content_height,
        calc(100vh - 152px)
      );
      padding: var(
        --nn-chronos-modal_chronos-modal-content_padding,
        0 48px 0 64px
      );
    }
    .slider__header {
      align-items: start;
      background: var(--nn-chronos-modal_slider__header_background-color, #fff)
        no-repeat 0 0;
      border: var(--nn-chronos-modal_slider__header_border, 0);
      border-radius: var(
        --nn-chronos-modal_slider__header_border-radius,
        32px 0 0 0
      );
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: start;
      min-height: var(--nn-chronos-modal_slider__header_min-height, 152px);
      max-width: var(--nn-chronos-modal_slider__header_max-width, 80%);
      padding: var(--nn-chronos-modal_slider__header_padding, 32px 76px 0 64px);
      width: var(--nn-chronos-modal_slider__header_width, 786px);
      position: fixed;
      right: 0;
      top: 0;
      z-index: 1;
    }
    .chrn__text {
      display: flex;
      flex-direction: column;
      justify-content: start;
      text-align: left;
    }
    .chrn__text--confirm {
      align-items: center;
      gap: var(--nn-chronos-modal_chrn__text--confirm_gap, 25px);
      justify-content: normal;
      margin: var(--nn-chronos-modal_chrn__text--confirm_margin, 30px 0);
      text-align: center;
    }
    .chrn__text--bold {
      font-family: 'font-heavy';
      font-weight: 400;
      line-height: calc(4px + 2ex);
    }
    .chrn__text--light {
      font-family: 'font-light';
      font-weight: 400;
      line-height: calc(4px + 2ex);
    }
    .chrn__text--big-title {
      font-size: var(
        --nn-chronos-modal_chrn__text--big-title_font-size,
        _2.2rem
      );
      font-weight: 900;
    }
    .loader {
      backdrop-filter: blur(4px);
      background-color: rgba(219, 219, 219, 0.5);
      border-radius: 32px 0 0 32px;
      height: 100%;
      opacity: 1;
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
    /* Form Content part */
    .ct-form__button,
    .ct-form__button:active,
    .ct-form__button:focus,
    .ct-form__button:visited,
    .ct-form__button:hover {
      align-items: center;
      background: var(--nn-chronos-modal_ct-form__button_background, #010101);
      border: var(--nn-chronos-modal_ct-form__button_borer, 0);
      border-radius: var(
        --nn-chronos-modal_ct-form__button_border-radius,
        32px
      );
      box-shadow: none;
      color: var(--nn-chronos-modal_ct-form__button_color, #f8f8f8);
      cursor: pointer;
      display: flex;
      font-family: 'font-medium';
      font-size: var(--nn-chronos-modal_ct-form__button_font-size, 18px);
      height: var(--nn-chronos-modal_ct-form__button_height, 48px);
      justify-content: center;
      margin: var(--nn-chronos-modal_ct-form__button_margin, auto);
      max-width: 100%;
      padding: var(--nn-chronos-modal_ct-form__button_padding, 0 24px);
      width: var(--nn-chronos-modal_ct-form__button_width, 260px);
    }
    .ct-form__button:disabled {
      background: var(
        --nn-chronos-modal_ct-form__button--disabled_background,
        #7c7c7c
      );
      cursor: not-allowed;
    }
    .ct-form__button:hover {
      filter: brightness(125%);
    }
    .ct-form__inputs-line {
      align-items: stretch;
      display: flex;
      flex-direction: var(
        --nn-chronos-modal_ct-form__inputs-line_flex-direction,
        row
      );
      flex-wrap: nowrap;
      gap: var(--nn-chronos-modal_ct-form__inputs-line_gap, 20px);
      margin-bottom: var(
        --nn-chronos-modal_ct-form__inputs-line_margin-bottom,
        25px
      );
    }
    .ct-form__input {
      align-items: center;
      background-color: var(--system-selected-bg, #f2f6fd);
      border: none;
      border-radius: var(--nn-chronos-modal_ct-form__input_border-radius, 6px);
      display: flex;
      font-family: 'font-light';
      font-size: var(--nn-chronos-modal_ct-form__input_font-size, 14px);
      justify-content: flex-start;
      height: var(--nn-chronos-modal_ct-form__input_height, 48px);
      padding: var(--nn-chronos-modal_ct-form__input_padding, 0 16px);
      margin: var(--nn-chronos-modal_ct-form__input_margin, 0 0 10px);
      outline: none;
      width: 100%;
    }
    .ct-form__input:valid {
      outline: 1px solid
        var(--nn-chronos-modal_ct-form__input--valid_outline-color, #91c762);
    }
    .ct-form__select {
      font-family: 'font-light';
      height: var(--nn-chronos-modal_ct-form__select_height, 50px !important);
    }
    option {
      height: var(--nn-chronos-modal_option_height, 50px);
    }
    .ct-form__end-form {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: var(--nn-chronos-modal_ct-form__end-form_margin, 10px 0 40px);
    }
    .ct-form__input-label {
      align-items: start;
      color: var(--nn-chronos-modal_ct-form__input-label_color, #000);
      display: flex;
      flex-basis: auto;
      font-family: 'font-heavy';
      font-weight: 400;
      flex-direction: column;
      flex-shrink: 0;
      flex-wrap: nowrap;
      font-size: var(--nn-chronos-modal_ct-form__input-label_font-size, 14px);
      gap: var(--nn-chronos-modal_ct-form__input-label_gap, 8px);
      justify-content: flex-start;
      width: var(
        --nn-chronos-modal_ct-form__input-label_width,
        calc(50% - 10px)
      );
    }
    .block-rgpd {
      border-top: 1px solid
        var(--nn-chronos-modal_block-rgpd_borer-top-color, #a8a8a8);
      font-size: var(--nn-chronos-modal_block-rgpd_font-size, 12px);
      padding: var(--nn-chronos-modal_block-rgpd_padding, 32px 0);
    }
    .block-rgpd p {
      color: var(--nn-chronos-modal_block-rgpd_p_color, #686868);
      line-height: calc(4px + 2ex);
    }
    .block-rgpd p:first-child {
      font-size: var(
        --nn-chronos-modal_block-rgpd_p--first-child_font-size,
        1.175em
      );
    }
    .hide {
      display: none;
    }
    .heading-02 {
      color: var(--nn-chronos-modal_heading-02_color, #000);
      font-family: 'font-heavy';
      font-size: var(--nn-chronos-modal_heading-02_font-size, 40px);
      line-height: calc(2ex + 4px);
    }
    .heading-03 {
      color: var(--nn-chronos-modal_heading-03_color, #000);
      font-family: 'font-heavy';
      font-size: var(--nn-chronos-modal_heading-03_font-size, 32px);
      line-height: calc(2ex + 4px);
      margin: var(--nn-chronos-modal_heading-03_margin, 0 0 32px);
      padding: var(--nn-chronos-modal_heading-03_padding, 0);
    }
    .ct-form__inputs-line:nth-child(2) {
      margin: var(
        --nn-chronos-modal_ct-form__inputs-line--nth-child--2_margin,
        24px 0
      );
    }
    .not-visible {
      visibility: hidden;
    }
    @media (max-width: 767px) {
      :host {
        --nn-chronos-modal_slider__header_border-radius: 0;
        --nn-chronos-modal_slider__header_min-height: 115px;
        --nn-chronos-modal_slider__header_padding: 28px 44px 16px 16px;
        --nn-chronos-modal_slider__header_width: 100%;
        --nn-chronos-modal_slider__header_max-width: 100%;
        --nn-chronos-modal_chronos-modal-content_padding: 0 16px;
        --nn-chronos-modal_ct-form__input-label_width: 100%;
        --nn-chronos-modal_ct-form__inputs-line_margin-bottom: 0;
        --nn-chronos-modal_ct-form__inputs-line_flex-direction: column;
        --nn-chronos-modal_heading-02_font-size: 32px;
        --nn-chronos-modal_heading-03_font-size: 24px;
      }
      .slider__header {
        height: var(--nn-chronos-modal_slider__header_height, auto);
      }
      .not-visible {
        display: none;
      }
    }
    @media (max-width: 479px) {
      :host {
        --nn-chronos-modal_heading-02_font-size: 26px;
        --nn-chronos-modal_heading-03_font-size: 20px;
      }
    }
  `;

  @property({ type: Object }) timeSlots: DateTimeSlots[] = [];

  @property({ type: String }) responseFromSubmit:
    | 'success'
    | 'error'
    | 'not_available'
    | '' = '';

  @property({ type: Boolean }) isCaptchaValid = false;

  asapTimeSlot: Partial<{ date: string; time: Timeslots }> = {};

  availableTimeSlots: DateTimeSlots[] = [];

  displayMode: 'form' | 'success' | 'error' = 'form';

  displaySelectTime = false;

  haveReceivedTimeSlots = false;

  isLoading = true;

  form: Record<string, unknown> = {};

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);

    this.onInit();
  }

  onInit(): void {
    // Here we add a listener on form inputs to format data in this.form object
    const inputIds = ['lastname', 'firstname', 'phone', 'date'];
    inputIds.forEach(inputId => {
      this.addListenerOnInput(inputId);
    });

    // Listener on form submit button
    const infoDateForm = this.shadowRoot?.getElementById('select-date-form');
    infoDateForm?.addEventListener('submit', e => {
      e.preventDefault();

      // Here we verify each form validity
      const infoClientForm = this.shadowRoot?.getElementById(
        'info-client-form'
      ) as HTMLFormElement;
      if (!infoClientForm.checkValidity()) {
        infoClientForm.reportValidity();
      } else if (!(infoDateForm as HTMLFormElement)) {
        (infoDateForm as HTMLFormElement).reportValidity();
      } else {
        this.isLoading = true;
        this.requestUpdate();
        // We send form content via onSubmit customEvent
        // If asap date is selected, we assign here before send
        if (this.form.date === 'asap') {
          this.form = {
            ...this.form,
            date: this.asapTimeSlot.date,
            time: JSON.stringify(this.asapTimeSlot.time),
          };
        } else {
          this.form = {
            ...this.form,
            time: this.form.time as string,
          };
        }

        this.dispatchEvent(
          new CustomEvent('onSubmit', {
            detail: {
              event: e,
              data: this.form,
            },
          })
        );
      }
    });

    // Listener on dateInput change
    const dateInput = this.shadowRoot?.getElementById('date');
    dateInput?.addEventListener('input', async e => {
      // @ts-ignore
      if (e?.srcElement?.value !== 'asap') {
        // When a date is selected, we add listener on timeInput and display it
        this.displaySelectTime = true;
        await this.requestUpdate();
        this.addListenerOnInput('time');
        // @ts-ignore
      } else if (e?.srcElement?.value === 'asap') {
        // Maybe we need to remove eventListener? Change addListenerOnInput if yes
        // this.shadowRoot?.getElementById('time')?.removeEventListener('input', () => {});

        // If asap is selected, datas are assigned on submit event
        this.displaySelectTime = false;
        this.requestUpdate();
      }
    });
  }

  protected updated(_changedProperties: PropertyValues) {
    if (
      this.timeSlots &&
      this.timeSlots.length &&
      !this.haveReceivedTimeSlots
    ) {
      // Call destination Id is the same for all days and we need it to post chronos
      this.form.callDestinationId = this.timeSlots[0].id;
      this.checkSlotsAndAssignAsap(this.timeSlots);
      this.haveReceivedTimeSlots = true;
      this.isLoading = false;
      this.requestUpdate();
    }
    if (this.responseFromSubmit !== '') {
      if (this.responseFromSubmit === 'success') {
        if (this.displayMode !== 'success') {
          this.displayMode = 'success';
          this.requestUpdate();
        }
      } else if (
        this.responseFromSubmit === 'error' ||
        this.responseFromSubmit === 'not_available'
      ) {
        if (this.displayMode !== 'error') {
          this.displayMode = 'error';
          this.requestUpdate();
        }
      }
      this.isLoading = false;
    }

    super.updated(_changedProperties);
  }

  addListenerOnInput(inputId: string) {
    this.shadowRoot?.getElementById(inputId)?.addEventListener('input', e => {
      // @ts-ignore
      this.form[inputId] = e?.srcElement?.value;
    });
  }

  /**
   * This function check if at least one slot is available.
   * If true, it assign the first finded slot to asap slot
   * Else, it define error
   * @param timeSlots
   */
  checkSlotsAndAssignAsap(timeSlots: DateTimeSlots[]) {
    const onlyAvailableDatetimeSlots = timeSlots
      .map(timeslotItem => ({
        ...timeslotItem,
        timeslots: timeslotItem.timeslots.filter(
          timeslot => timeslot.available
        ),
      }))
      .filter(dateTimeSlots => dateTimeSlots.timeslots.length);
    if (!onlyAvailableDatetimeSlots.length) {
      this.isLoading = false;
      if (this.displayMode !== 'error') {
        this.responseFromSubmit = 'error';
        this.displayMode = 'error';
        this.requestUpdate();
      }
    } else {
      this.form.date = 'asap';
      this.asapTimeSlot = {
        date: onlyAvailableDatetimeSlots[0].date,
        time: onlyAvailableDatetimeSlots[0].timeslots[0],
      };
    }
    this.availableTimeSlots = onlyAvailableDatetimeSlots;
  }

  closeModal(): void {
    const close = this.shadowRoot?.getElementById('close-modal-button');
    // @ts-ignore
    (close as HTMLElement)?.dataset.closeModal = String(true);
    this.dispatchEvent(new CustomEvent('onCloseChronosModal'));
    this.resetComponent('CLOSE');
  }

  resetComponent(action: 'RELOAD' | 'CLOSE'): void {
    this.timeSlots = [];
    this.availableTimeSlots = [];
    this.asapTimeSlot = {};
    this.displaySelectTime = false;
    this.haveReceivedTimeSlots = false;
    this.displayMode = 'form';
    this.responseFromSubmit = '';
    this.form = {};
    this.isLoading = true;
    if (action === 'RELOAD') {
      this.dispatchEvent(new CustomEvent('onResetComponent'));
    }
    this.requestUpdate();
    // Don't want to use setTimeout but don't component is not correctly reset without it
    setTimeout(() => {
      this.onInit();
    }, 50);
  }

  renderLoader() {
    if (this.isLoading) {
      return html`
        <div class="loader">
          <nn-loader style="width: 100%;"></nn-loader>
        </div>
      `;
    }
    return '';
  }

  renderAvailableDateSlots() {
    const htmlOptions: { originalDate: string; formattedDate: string }[] = [];
    this.availableTimeSlots.forEach(availableDateSlot => {
      const splitDate = availableDateSlot.date.split('-');
      const date = new Date(
        Number(splitDate[0]),
        Number(splitDate[1]) - 1,
        Number(splitDate[2])
      );
      htmlOptions.push({
        formattedDate: date.toLocaleDateString('fr-FR', {
          weekday: 'long',
          month: 'long',
          day: 'numeric',
        }),
        originalDate: availableDateSlot.date,
      });
    });
    return html`
      ${htmlOptions.map(
        date =>
          html`<option value="${date.originalDate}">
            ${date.formattedDate}
          </option>`
      )}
    `;
  }

  renderAvailableTimeSlots() {
    // @ts-ignore
    const htmlOptions: Timeslots[] = this.availableTimeSlots
      // @ts-ignore
      .find(item => item.date === this.form?.date).timeslots;
    return html`
      ${htmlOptions.map(
        time =>
          html`<option value="${JSON.stringify(time)}">
            ${time.start.replace(/:00$/g, '')} -
            ${time.end.replace(/:00$/g, '')}
          </option>`
      )}
    `;
  }

  renderContentForm() {
    if (this.displayMode === 'form') {
      return html`
        <p class="heading-03">
          Laissez-nous vos coordonnées,<br />
          un conseiller vous rappellera gratuitement.
        </p>
        <form id="info-client-form">
          <div class="ct-form__inputs-line">
            <label class="ct-form__input-label" for="lastname"
              ><span>Votre nom</span>
              <input
                class="ct-form__input"
                id="lastname"
                name="lastname"
                pattern="^[a-zA-ZÀ-ÿ]{2,20}$"
                placeholder="Nom"
                required
                type="text"
              />
            </label>
            <label class="ct-form__input-label" for="firstname"
              ><span>Votre prénom</span>
              <input
                class="ct-form__input"
                id="firstname"
                name="firstname"
                pattern="^[a-zA-ZÀ-ÿ]{2,20}$"
                placeholder="Prénom"
                required
                type="text"
              />
            </label>
          </div>

          <div class="ct-form__inputs-line">
            <label class="ct-form__input-label" for="phone"
              ><span>Numéro sur lequel vous souhaitez être appelé</span>
              <input
                class="ct-form__input"
                id="phone"
                name="phone"
                type="tel"
                pattern="0[0-9]{9}"
                placeholder="06 00 00 00 00"
                required
              />
            </label>
          </div>
        </form>

        <form id="select-date-form">
          <div class="ct-form__inputs-line">
            <label class="ct-form__input-label" for="date"
              >&Agrave; quel moment souhaitez-vous être rappelé&nbsp;?
              <select
                class="ct-form__input ct-form__select"
                id="date"
                name="date"
                required
              >
                <option value="asap">Dès que possible</option>
                ${this.renderAvailableDateSlots()}
              </select>
            </label>
            ${this.renderSelectTimeInput()}
          </div>

          <div class="ct-form__end-form">
            <div style="margin: 0 auto 20px;">
              <slot name="captcha-zone"></slot>
            </div>
            <button
              type="submit"
              class="ct-form__button"
              ?disabled="${!this.isCaptchaValid}"
            >
              Demander un rappel
            </button>
          </div>
        </form>
      `;
    }
    return '';
  }

  renderSelectTimeInput() {
    if (this.displaySelectTime) {
      return html`
        <label class="ct-form__input-label" for="date"
          ><span class="not-visible"
            >&Agrave; quel moment souhaitez-vous être rappelé&nbsp;?</span
          >
          <select
            class="ct-form__input ct-form__select"
            id="time"
            name="time"
            required
          >
            <option value="" disabled selected>Choisissez un créneau</option>
            ${this.renderAvailableTimeSlots()}
          </select>
        </label>
      `;
    }
    return '';
  }

  renderFinalDateMessage() {
    const splitDate = (this.form.date as string).split('-');
    const date = new Date(
      Number(splitDate[0]),
      Number(splitDate[1]) - 1,
      Number(splitDate[2])
    );
    const displayTime = (moment: 'start' | 'end') =>
      JSON.parse(this.form.time as string)
        [moment].replace(/:00$/g, '')
        .replace(':', ' h ');

    return html`Un conseiller vous rappellera le
      <b
        >${date.toLocaleDateString('fr-FR', {
          weekday: 'long',
          month: 'long',
          day: 'numeric',
        })}</b
      >
      entre <b>${displayTime('start')}</b> et <b>${displayTime('end')}</b>`;
  }

  renderContentSuccess() {
    if (this.displayMode === 'success') {
      return html`
        <div class="chrn__text chrn__text--confirm">
          <img
            width="45px"
            height="45px"
            alt="Success icon"
            src="${assetsPath}/icons/success.svg"
          />
          <div class="heading-03">
            Votre demande de rappel a bien été enregistrée.
          </div>
          <span class="chrn__text--bold">${this.renderFinalDateMessage()}</span>
        </div>
        <div class="chrn__text chrn__text--confirm">
          <button
            @click="${this.closeModal}"
            class="ct-form__button"
            id="close-modal-button"
            data-close-modal
          >
            Fermer
          </button>
        </div>
      `;
    }
    return '';
  }

  renderContentError() {
    if (this.displayMode === 'error') {
      return html`
        <div class="chrn__text chrn__text--confirm">
          <img
            width="45px"
            height="45px"
            alt="Error icon"
            src="${assetsPath}/icons/error.svg"
          />
          <div class="heading-03">
            Oups !<br />
            ${this.responseFromSubmit === 'not_available'
              ? 'Une demande de rappel a déjà été enregistrée pour ce numéro.'
              : "Nous n'avons pas pu trouver de créneau disponible."}
          </div>
          <span class="chrn__text--bold"
            >Veuillez réessayer d'ici quelques minutes.</span
          >
          <span class="chrn__text--light"
            >Si le problème persiste, vous pouvez nous joindre directement par
            téléphone<br />
            au <b>3420</b> (service gratuit +&nbsp;prix appel).
          </span>
        </div>
        <div class="chrn__text chrn__text--confirm">
          <button
            class="ct-form__button"
            @click=${() => {
              this.resetComponent('RELOAD');
            }}
          >
            Actualiser
          </button>
        </div>
      `;
    }
    return '';
  }

  render() {
    return html`
      <nn-modal
        id="nn-modal"
        mode="lateral"
        .customHeader=${true}
        @onClose="${this.closeModal}"
      >
        <slot name="openButton" slot="openButton"></slot>

        <div slot="custom-header" class="slider__header">
          <div class="chrn__text">
            <div class="heading-02">Une question, un souci&nbsp;?</div>
          </div>
        </div>

        <div slot="content" class="chronos-modal-content">
          ${this.renderLoader()} ${this.renderContentForm()}
          ${this.renderContentSuccess()} ${this.renderContentError()}

          <div class="block-rgpd">
            <p>
              95&nbsp;% des utilisateurs ne liront pas les mentions légales...
              et on vous comprend&nbsp;!
            </p>
            <p>
              Ces informations sont nécessaires au traitement de votre demande,
              à moins qu’elles ne soient indiquées comme étant facultatives.
              Elles font l’objet d’un traitement informatisé, sous la
              responsabilité du Président Directeur Général de la société
              Nordnet, et sont destinées aux services et partenaires de Nordnet
              chargés de son exécution et de toutes suites qui pourraient en
              résulter. L’assistance aux clients peut être en partie réalisée
              hors de l’Union européenne, sous couvert des clauses
              contractuelles type.
            </p>
            <p>
              Vous garantissez l’exactitude des éléments personnels communiqués
              et vous vous engagez à les maintenir à jour. Vous êtes informé que
              dans le cadre de votre Offre, vous êtes susceptible de recevoir
              des informations relatives à la gamme de produits ou services à
              laquelle vous avez souscrit à moins que vous ne vous y opposiez.
              Les traitements sont réalisés sur les bases légales&nbsp;:
              contractuelle, respect d’obligations légales et intérêt légitime
              (prospection).
            </p>
            <p>
              Conformément aux dispositions légales et réglementaires
              applicables, vous disposez notamment d’un droit d’accès, de
              rectification et d’opposition au traitement de vos données
              personnelles, à la réception d’informations commerciales, ainsi
              qu’à la transmission à des tiers d’informations personnelles vous
              concernant (y compris les services d’annuaires) à moins que cette
              transmission ne soient nécessaire à l’exécution de l’Offre. Vous
              disposez également du droit de formuler des directives générales
              ou particulières à la conservation, à l’effacement et à la
              communication de vos données à caractère personnel après votre
              décès.
            </p>
            <p>
              Pour exercer vos droits, veuillez adresser un courrier à Nordnet -
              Département Gestion Clients - 245 Boulevard de Tournai (5<sup
                >ème</sup
              >
              étage) -&nbsp;CS&nbsp;20458&nbsp;- 59664 VILLENEUVE D’ASCQ CEDEX
              ou un courriel à l’adresse&nbsp;: coordonnees@nordnet.com (seules
              les demandes portant sur les données à caractère personnel seront
              traitées). Les données à caractère personnel (DCP) sont conservées
              en base active le temps nécessaire à l’accomplissement des
              finalités visées ci-dessus, défini selon la nature de la(des)
              donnée(s) visée(s), des finalités, ainsi que des personnes
              concernées, sans préjudice des obligations de conservation légale
              ou des délais de prescription. Vous garantissez disposer de
              l’autorisation des tiers dont les coordonnées ont éventuellement
              été communiquées par vos soins et vous vous engagez à les informer
              des droits dont ils disposent relativement aux DCP collectées.
            </p>
            <p>
              Si vous n’êtes pas l’utilisateur de l’offre souscrite, vous en
              restez responsable envers Nordnet. Vous vous engagez dès lors à
              lui fournir les conditions contractuelles comme toute information,
              conseil ou mise en garde nécessaires, et à permettre
              l’identification de l’utilisateur le cas échéant. Par ailleurs,
              vous pouvez vous inscrire gratuitement sur une liste d’opposition
              dénommée "Bloctel" afin de ne plus être démarché téléphoniquement,
              via le site www.bloctel.gouv.fr. Nous vous rappelons qu’en
              complément des stipulations des conditions contractuelles
              applicables relatives aux DCP, la politique de traitement des DCP
              de Nordnet est accessible sur www.nordnet.com.
            </p>
          </div>
        </div>
      </nn-modal>
    `;
  }
}
